import { establishmentHexToRgbChannels } from '../constants/brandColors';
import {
  getReadableTextOnBackgroundHex,
  getReadableTextOnBrandGradientHex,
  gradientGlassRgbForForeground,
  pickNavBrandAccentHex,
} from './bannerContrast';

export interface EstablishmentDocumentColors {
  primary: string;
  secondary: string;
  /** Primária usada em CTAs (`--color-primary`); pode divergir da primária de branding no login. */
  chromePrimary?: string;
  navAccentIsDark?: boolean;
}

/** Aplica variáveis CSS de white-label no `document` (login, admin, home do tenant). */
export function applyEstablishmentDocumentColors({
  primary,
  secondary,
  chromePrimary,
  navAccentIsDark = false,
}: EstablishmentDocumentColors): void {
  const root = document.documentElement;
  const effectivePrimary = chromePrimary ?? primary;

  root.style.setProperty('--color-primary', effectivePrimary);
  root.style.setProperty('--color-secondary', secondary);
  root.style.setProperty('--color-primary-rgb', establishmentHexToRgbChannels(effectivePrimary));
  root.style.setProperty('--color-secondary-rgb', establishmentHexToRgbChannels(secondary));
  root.style.setProperty('--color-on-primary', getReadableTextOnBackgroundHex(effectivePrimary));
  root.style.setProperty('--color-on-secondary', getReadableTextOnBackgroundHex(secondary));

  const gradientFg = getReadableTextOnBrandGradientHex(primary, secondary);
  root.style.setProperty('--establishment-gradient-foreground', gradientFg);
  root.style.setProperty(
    '--establishment-gradient-glass-rgb',
    gradientGlassRgbForForeground(gradientFg)
  );
  root.style.setProperty(
    '--color-nav-accent',
    pickNavBrandAccentHex(primary, secondary, navAccentIsDark)
  );
}
